export default __webpack_public_path__ + "static/media/back.6ca37b9b.svg";